// este componente foi criado para uma demanda especial do COVID-19
import React, {useState, useEffect, useRef} from 'react';
import { Button } from "@maxmilhas/hangar-components-atomic/public";
import { css } from 'emotion';
import { postCancellationProtocol, uploadImage } from '../../../../shared/requests-api';


const overlay = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    opacity: 0.4;
    background-color: #000;
    z-index: 9999;
`

const wrapper = `
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    padding: 0 16px 36px;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    z-index: 99999;
    overflow-y: scroll;

    @media (min-width: 768px) {
        top: 50%;
        left: 50%;
        width: 100%;
        max-width: 530px;
        height: auto;
        max-height: 81vh;
        padding: 24px;
        border-radius: 8px;
        transform: translate(-50%, -50%);
    }
`

const  closeButton = `
    align-self: flex-end;
    background: transparent;
    border: 0;
    appearance: none;

    @media (min-width: 1024px) {
        display: none;
    }

    i {
        font-size: 25px;
    }
`

const coverImage = `
    margin: 15px auto 0;
    width: 100%;

    @media (min-width: 768px) {
        width: 80%;
    }
`

const mainTitleStyle = `
    font-size: 16px;
    font-weight: bold;
    color: #223254;

    @media (min-width: 768px) {
        font-size: 20px;
    }
`

const buttonWrapper = `
    display: flex;
    alignb-items: center;
    justify-content: flex-end;
`

const cancelButtonStyle = `
    margin-right: 15px;
    max-width: 110px;
    font-weight: 600 !important;
    color: #1abc9c !important;
    background-color: #fff !important;
    box-shadow: none !important;
`

const sendButtonStyle = `
    border: 0;
    height: 48px;
    font-weight: 600 !important;
    box-shadow: none !important;
`

const submitedTitle = `
    color: #1abc9c;
`

const submitedParagraph = `
    margin-bottom: 20px;
`

const SpecialCancellationForm = ({ order, closeForm, limitDate }) => {
    const [formSubmited, setFormSubmited] = useState(false);


    // const submitProtocol = e => {
    //     e.preventDefault();
    //     const orderCode = order.order.code;
        
    //     const data = { orderCode, reasonCode: '', reasonOption: '', justification: '', files: [], subscribedForNews: true };


    //     postCancellationProtocol(data)
    //         .then(response => {
    //             setFormSubmited(true);
    //         })
    //         .catch(err => console.error(err))
    // }

    return (
        <>
            <div onClick={() => closeForm()} className={css`${overlay}`}></div>
            {!formSubmited && (
                <form className={css`${wrapper}`}>
                    <button className={css`${closeButton}`} onClick={() => closeForm()}><i className="icon-max-navigation-close"></i></button>

                    <img className={css`${coverImage}`} src="https://website-hangar.s3.amazonaws.com/2020/02/14/protocol-cover.svg" />

                    <h3 className={css`${mainTitleStyle}`}>Atenção!</h3>

                    <p>A data do seu voo é depois do dia {limitDate}. Por isso, a alteração dessa passagem não seguirá as mesmas condições da companhia 
                    para cancelamento ou remarcação por coronavírus.</p>

                    <p>Você pode aguardar mais alguns dias e verificar no nosso site se a situação da sua passagem mudou. Ou se preferir você pode solicitar o cancelamento com taxas.</p>

                    {/* <p>Você pode aguardar mais alguns dias e receber nossa notificação se a companhia mudar a data dos voos que serão cobertos por coronavírus. 
                    Ou se preferir você pode solicitar o cancelamento com taxas.</p> */}

                    <div className={css`${buttonWrapper}`}>
                        {/* <Button onClick={() => closeForm()} className={css`${cancelButtonStyle}`}>Cancelar</Button>
                        <Button onClick={(e) => submitProtocol(e)} className={css`${sendButtonStyle}`}>Receber notificação do seu voo por e-mail</Button> */}
                        <Button onClick={() => closeForm()} className={css`${sendButtonStyle}`}>Ok, entendi</Button>
                    </div>
                </form>
            )}

            {/* {formSubmited && (
                <div className={css`${wrapper}`}>
                    <img className={css`${coverImage}`} src="https://website-hangar.s3.amazonaws.com/2020/02/14/protocol-cover.svg" />

                    <h3 className={css`${submitedTitle}`}>Notificação ativada</h3>

                    <p className={css`${submitedParagraph}`}>
                        Enviaremos um alerta para se e-mail se a companhia aérea alterar a data dos voos que serão tratados de acordo
                        com as regras do coronavírus.
                    </p>

                    <Button onClick={() =>  window.location.pathname = "/cliente/minhas-viagens-light"} className={css`${sendButtonStyle}`}>Ok, entendi</Button>
                </div>
            )} */}
        </>
    )
}

export default SpecialCancellationForm;